import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="policy-page">
      <h1>Privacy Policy</h1>
      <div className="policy-content">
        <section>
          <h2>1. Introduction</h2>
          <p>At Mycelo, we respect your privacy and are committed to protecting your personal data. This privacy policy will inform you how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.</p>
        </section>

        <section>
          <h2>2. The Data We Collect About You</h2>
          <p>Personal data means any information about an individual from which that person can be identified. We may collect, use, store and transfer different kinds of personal data about you including your name, email address, and information about how you use our website.</p>
        </section>

        <section>
          <h2>3. How We Use Your Personal Data</h2>
          <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data to provide you with information about our products and services, to manage our relationship with you, and to improve our website and services.</p>
        </section>

        <section>
          <h2>4. Data Security</h2>
          <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. We also limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know.</p>
        </section>

        <section>
          <h2>5. Your Legal Rights</h2>
          <p>Under certain circumstances, you have rights under data protection laws in relation to your personal data including the right to request access to your personal data, request correction of your personal data, request erasure of your personal data, object to processing of your personal data, and request restriction of processing your personal data.</p>
        </section>

        <section>
          <h2>6. Contact Us</h2>
          <p>If you have any questions about this privacy policy or our privacy practices, please contact us at contact@mycelo.io.</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
